<script setup lang="ts">
import { ref, watch, computed } from "vue";
import { useRouter } from "vue-router";

import { useComponentErrorCapture } from "@/mixins/error";

import SectionHome from "@/components/home/SectionHome.vue";
import SectionCustomiseRemote from "@/components/customise-remote/SectionCustomiseRemote.vue";
import QuickTips from "@/components/home/QuickTips.vue";

const router = useRouter();
useComponentErrorCapture();

const pageHome = ref();

const isCustomise = computed(() => {
  return router.currentRoute.value && router.currentRoute.value.meta && router.currentRoute.value.meta.customiseRemote == true;
});

watch(isCustomise, (val) => {
  if (val) {
    pageHome.value && pageHome.value.scrollTo({ top: 0, left: 0 });
  }
})

</script>
<template>
  <Suspense>
    <div class="page-home" :class="{'page-home--customise': isCustomise}" ref="pageHome">
      <SectionHome :active="isCustomise == false" />
      <SectionCustomiseRemote :folded="isCustomise == false" />
      <QuickTips class="quick-tips--tablet" :class="{'quick-tips--inactive': isCustomise == true}" />
    </div>
  </Suspense>
</template>
